module.exports = __webpack_public_path__ + "static/media/clear.97067bdf.png";


//////////////////
// WEBPACK FOOTER
// ./src/resources/assets/images/clear.png
// module id = 1328
// module chunks = 0